module.exports = __webpack_public_path__ + "img/saintkentigern-img.cbae95f2.jpg";